import { DatePickerField } from "@/components/date-picker";
import { FilterCard, FilterLabel } from "./primitives";

export function DobCard({
  value,
  onChange,
  error,
  className,
  disabled,
}: {
  value: string;
  onChange: (next: string) => void;
  /** Inline validation message rendered under the field. */
  error?: string;
  className?: string;
  disabled?: boolean;
}) {
  // Drop the fixed height when an error is shown so the message has room.
  const cardClass =
    className ?? (error ? "justify-center w-full" : "h-[80px] justify-center w-full");
  return (
    <FilterCard className={cardClass}>
      <FilterLabel>Date of birth</FilterLabel>
      <DatePickerField
        value={value}
        onChange={onChange}
        ariaLabel="Date of birth"
        placeholder="YYYY-MM-DD, YYYY-MM or YYYY"
        className="w-full"
        disabled={disabled}
      />
      {error && (
        <p role="alert" className="text-tiny font-medium text-red-600">
          {error}
        </p>
      )}
    </FilterCard>
  );
}
